import { render, staticRenderFns } from "./VideoIntroduce.vue?vue&type=template&id=78488423&scoped=true&"
import script from "./VideoIntroduce.vue?vue&type=script&lang=js&"
export * from "./VideoIntroduce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78488423",
  null
  
)

export default component.exports